<template>
  <div id="app">
    <router-view/>
    
    <Loading v-if="$store.state.loading"/>
    <Success v-if="$store.state.showSuccess" />
    <Error v-if="$store.state.showError" />
  </div>
</template>

<script>
import Loading from "@/components/Loading"
import Success from '@/components/SuccessModal'
import Error from '@/components/FailureModal'
export default {
  components: {Loading, Success, Error}
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;600;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap');
#app {
  font-family: 'Nunito', Montserrat, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.l-modal{
  display: block;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0, 0.3);
}
.loading-modal{
  min-height: 350px; 
}
.ox{
  color:  #002147
}
</style>
